import { VuesticPlugin } from 'vuestic-ui';
import { createApp } from "vue";
import { createI18n } from 'vue-i18n';
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'vuestic-ui/dist/vuestic-ui.css';
import 'font-awesome/css/font-awesome.css';
import vuesticGlobalConfig from './services/vuestic-ui/global-config';
import VueSweetalert2 from 'vue-sweetalert2';
import './assets/css/fontDBOzone.css';
import './assets/css/MaterialIcons.css';
const locales = require.context('./i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i);
const messages = {} as any;
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
const i18nConfig = {
    locale: 'en',
    legacy: false,
    fallbackLocale: 'en',
    fallbackWarn: false,
    missingWarn: false,
    silentFallbackWarn: true,
    silentTranslationWarn: true,
    globalInjection: true,
    messages:messages
  }

const app = createApp(App);
app.config.warnHandler = function (msg, vm, trace) {
  return null
}

app.use(store);
app.use(router);
app.use(createI18n(i18nConfig))

app.use(VuesticPlugin, vuesticGlobalConfig);
app.use(VueSweetalert2);
app.mount('#app');